import React from 'react'

/* doc
---
title: ModalBackground
name: ModalBackground
category: React - Bulma
---

A `ModalBackground` component based on Bulma `.modal-background`. This displays the
faded background behind the Modal

This should be used with `Modal`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalContent>
      ...
    </ModalContent>
  </Modal>
```
*/
function ModalBackground(props) {
  const { className, children, ...rest } = props

  const classes = [
    'bulma-modal-background',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default ModalBackground
